module.exports = __webpack_public_path__ + "static/media/page-not-found-404.22e4295e.svg";